var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',_vm._l((_vm.columns),function(item){return _c('th',{key:item.prop,style:({
      'min-width': ("" + (item['min-width'])),
      'max-width': ("" + (item['max-width']))
    }),attrs:{"width":item.width,"align":item.align || 'left'},domProps:{"innerHTML":_vm._s(item.label)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }